// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var TwoWay = function TwoWay(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.473 10.146L10.637 7.31 9.591 8.356l1.973 1.973H1.481v1.726h10.083l-1.973 1.972 1.046 1.046 2.836-2.835 1.046-1.046-1.046-1.046zM4.436 3.945l1.973-1.972L5.363.927 1.481 4.808 5.363 8.69l1.046-1.046-1.973-1.973h10.083V3.945H4.436z"
    }))
  );
};

export default TwoWay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/TwoWay.js
// module id = 1058
// module chunks = 0